"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClickOnScrollbar = isClickOnScrollbar;
exports.querySelectorAllShadows = querySelectorAllShadows;

function isClickOnScrollbar(event, document) {
  var target = event && event.path && event.path[0] || event && event.target;

  if (target) {
    var isHtml = target.tagName === 'HTML';
    var clientX = event && event.clientX || 0;
    var clientWidth = document && document.documentElement && document.documentElement.offsetWidth || 10000;
    var isOutsideView = clientX > clientWidth;
    return isHtml && isOutsideView;
  }

  return false;
}

function querySelectorAllShadows(selector) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
  var childShadows = Array.from(el.querySelectorAll('*')).map(function (elem) {
    return elem.shadowRoot;
  }).filter(Boolean);
  var childResults = childShadows.map(function (child) {
    return querySelectorAllShadows(selector, child);
  });
  var result = Array.from(el.querySelectorAll(selector));
  return result.concat(childResults).flat();
}